exports["NL"] = require("./NL.js");
exports["UK"] = require("./UK.js");
exports["DE"] = require("./DE.js");